import { render, staticRenderFns } from "./OverviewReportDetails.vue?vue&type=template&id=717e610b&scoped=true"
import script from "./OverviewReportDetails.vue?vue&type=script&lang=js"
export * from "./OverviewReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717e610b",
  null
  
)

export default component.exports